import React, { FC } from "react";
import { useHistory, useLocation } from "react-router-dom";


import { Tabs } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import CardMenu from "../../../shared/components/CourseComponents/CardMenu";

import { Students } from "../../../models/InstituteModel/students.model";

import { Details } from "./Details";
import  InstituteLeaderboard from "./Leaderboard";
import StudentAnalytics  from "./Analytics";
import StudentSubscriptions from "./Subscriptions";

import "./instituteStudentDetails.scss";

const { TabPane } = Tabs;

const StudentDetails: FC = () => {
  const { state }: { state: Students } = useLocation();
  const history = useHistory()
  return (
    <div className="page-view student-details__container">
      <div className="student-details-header__container">
        <div className="student-details-header__wrapper">
          <div className="header__left">
            <ArrowLeftOutlined onClick={() => history.goBack()}/>
            <div className="student-details__wrapper">
              <p className="student__name">{state?.name}</p>
              <p>{state?.id}</p>
            </div>
          </div>
          <div className="header__right">
            {/* <CardMenu
              menuText={"Student"}
              handleDelete={() => {}}
              handleEdit={() => {}}
            /> */}
          </div>
        </div>
      </div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Details" key="1">
          <Details/>
        </TabPane>
        <TabPane tab="Subscription" key="2">
          <StudentSubscriptions/>
        </TabPane>
        <TabPane tab="Analytics" key="3" >
          <StudentAnalytics/>
        </TabPane>
        <TabPane tab="Leaderboard" key="4">
          <InstituteLeaderboard/>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default StudentDetails;

